import axios from 'axios';

import { ErrorMessageType, ErrorCodeType } from 'common/components/CopyMagic/CopyMagic.types';
import { ERROR_MESSAGES } from 'common/components/CopyMagic/constants';

const getErrorMessageFor = (error: unknown): ErrorMessageType => {
  if (axios.isAxiosError(error)) {
    const errorCode: ErrorCodeType = error.response?.data?.code;

    if (errorCode && ERROR_MESSAGES[errorCode]) {
      return ERROR_MESSAGES[errorCode];
    }

    if (error.response?.status === 429) {
      return ERROR_MESSAGES.TOO_MANY_REQUESTS;
    }
  }

  return ERROR_MESSAGES.DEFAULT;
};

export default getErrorMessageFor;
